import React from "react";

export default function Chart({ children, title }) {
  return (
    <div className="flex flex-col bg-white rounded-md px-2 h-full items-center">
      <p className="py-2 w-full text-left font-semibold text-gray-800 dark:text-gray-300">
        {title}
      </p>
      {children}
    </div>
  );
}
